<template>
  <div :class="[
    'container',
    'container-footer',
    'bg-gray',
    !isMiniProgram ? 'container-nav' : ''
  ]">
    <van-nav-bar v-if="!isMiniProgram" :title="!isMiniProgram ? '个人中心' : ''" fixed :border=false
      :z-index=999></van-nav-bar>
    <section class="ds-my-top enroll-list flex bg-white all-c" @click="go('my-info')">
      <p class="ds-avatar mr10">
        <img src="../../assets/images/common/user-photo.jpg" v-if="!data.avatarUrl" />
        <img :src="data.avatarUrl" v-else />
      </p>
      <div class="flex-1">
        <h3 class="f20">{{ data.name }}</h3>
        <span class="f12 ds-opcity-60" v-if="data.nickname">微昵称：{{ data.nickname }}</span>
      </div>
      <p class="c-white ds-opcity-60">
        <span class="icon icon-mright lb-vm f18"></span>
      </p>
    </section>
    <van-cell-group class="mt10 bg-white set-cell-height" :border=false>
      <van-cell title="面试跟进" is-link @click="go('interview-list')">
        <span class="icon icon-interview c-gray f20 mr5" slot="icon"></span>
      </van-cell>
      <van-cell title="我的认证" :value="data.verified ? '已实名' : '未实名'" is-link @click="goAuthen">
        <span class="icon icon-vertify c-gray f20 mr5" slot="icon"></span>
      </van-cell>
      <van-cell title="我的协议" :value="contractStatusText" is-link @click="goContract">
        <span class="icon icon-iconxieyi c-gray f20 mr5" slot="icon"></span>
      </van-cell>
      <!-- <van-cell title="专属顾问" v-if="leader.ServicePersonName">
        <span class="icon icon-iconzhuanshuguwen c-gray f20 mr5" slot="icon"></span>
        <span class="c-orange f16 mr5">{{leader.ServicePersonName}}</span>
        <van-button type="default" size="small" round plain @click="callTel(leader.ServicePersonContactTel)"
                    v-if="leader.ServicePersonContactTel">{{leader.ServicePersonContactTel}}
        </van-button>
      </van-cell>
      <van-cell title="专属顾问" value="请等待系统分配" v-else>
        <span class="icon icon-iconzhuanshuguwen c-gray f20 mr5" slot="icon"></span>
      </van-cell> -->
      <!-- <van-cell title="客服热线">
        <span class="icon icon-call1 c-gray f20 mr5" slot="icon"></span>
        <van-button type="default" size="small" round plain @click="callTel('400-872-8880')">400-872-8880</van-button>
      </van-cell> -->
      <van-cell title="关于我们" is-link @click="go('about-me')">
        <span class="icon icon-feedback c-gray f20 mr5" slot="icon"></span>
      </van-cell>
      <van-cell title="
      退出登录" is-link @click="logout">
        <span class="icon icon-iconexit c-gray f20 mr5" slot="icon"></span>
      </van-cell>

    </van-cell-group>
    <div style="color: gray; text-align: center;font-size: 12px; margin-top: 10px;">当前版本：1.0.5</div>
   

    <tab-bar></tab-bar>
  </div>
</template>

<script>
import tabBar from '../../components/tab-bar';
import { getAppInfo, openDocument } from '../../libs/native-app';
import { checkDevice, getEnv } from '../../libs/util';
import api from '../../api';

export default {
  name: 'my-center',
  components: { tabBar },
  data() {
    return {
      data: {
        avatarUrl: "",
        consultantName: "",
        consultantPhone: "",
        customerService: "",
        name: "",
        nickname: "",
        ownFlag: true,
        phoneNumber: "",
        signed: 0,
        verified: true
      },
      leader: {
        FileUrlList: [],
        PersonRealName: '',
        PersonName: '',
        PersonSysNo: '',
        ServicePersonName: '',
        ServicePersonContactTel: '',
      },
      appVer: '',
      verType: '',
      authen: '',
      contracts: [],
      isMiniProgram: false,
      domainEnv: '',
    };
  },

  computed: {
    contractStatusText() {
      // 1:未签署(待签约)；2:已签署；3:已拒绝并取消；4:签署中
      switch (this.data.signed) {
        case 1:
          return '未签约';
        case 2:
          return '已签约';
        case 3:
          return '已拒绝';
        case 4:
          return '签署中';
        default:
          return '未知';
      }
    },
  },
 
  mounted() {
    
    this.checkDevice();
    this.init();
    // 
    // 检查是否为小程序环境
    if (typeof window !== 'undefined' && (window.__wxjs_environment === 'miniprogram' || (navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1))) {
      this.isMiniProgram = true;
    }

    // 监听页面可见性变化（从 e签宝 签署页面返回时刷新数据）
    this.handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log('页面回到前台，刷新签约状态');
        this.getLeaderInfo();
      }
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    // 移除监听
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  },
  methods: {
    async init() {
      try {
        // this.$loading();
        await this.getLeaderInfo();
        // await this.checkAuthen();
        // await this.getContract();
        // this.$loadingClose();
      } catch (e) {
        this.$toast(e.message);
      }
    },
    checkDevice() {
      let device = checkDevice();
      this.verType = device.isAndroid ? 'Android版' : 'iPhone版';
      this.getAppInfo();
    },
    async getAppInfo() {
      const ver = await getAppInfo();
      this.appVer = ver.version;
    },
    async getLeaderInfo() {
      // if (!this.$store.state.person || !this.$store.state.person.PersonSysNo) {
      //   this.$toast('请先登录');
      //   this.$router.replace('login');
      //   return;
      // }阻塞显示暂时注释
      // this.leader = await this.$store.dispatch('postData', {
      //   url: '/api/vpai/vleader/my_tab',
      //   data: { Extra: { PersonSysNo: this.$store.state.person.PersonSysNo } }
      // });
      // 临时改为 GET 请求
      this.leader = await api.get('/api/vpai/vleader/my_tab');
      this.data = this.leader.data || {};
      // if (this.leader) {
      //   // console.log
      //   // this.$store.state.person.LeaderPersonSysNo = this.leader.PersonSysNo;
      //   // this.$store.state.person.LeaderSysNo = this.leader.LeaderSysNo;
      //   // this.$store.commit('updatePerson', this.$store.state.person);
      // }
      // await this.initGenerateLeaderContract();
    },
    async initGenerateLeaderContract() {
      try {
        await this.$store.dispatch('postData', {
          url: '/recruit/GenerateLeaderContract',
          data: {
            Body: {
              LeaderSysNo: this.$store.state.person.LeaderSysNo
            }
          }
        });
      } catch (e) {
        this.$loadingClose();
        this.$toast(e.message);
      }
    },
    // async checkAuthen() {
    //   let res = await this.$store.dispatch('postData', {
    //     url: '/recruit/CheckAuthentication',
    //     data: {}
    //   });
    //   this.authen = res.AuthenticationStatus;
    // },
    // async getContract() {
    //   let res = await this.$store.dispatch('postData', {
    //     url: '/recruit/GetContractList',
    //     data: { Extra: { PersonSysNo: this.$store.state.person.PersonSysNo } }
    //   });
    //   // this.hasContracts = res.List.filter(item => item.ContractStatus === 10);
    //   this.contracts = res.List.filter(v => v.ContractStatus === 0);
    // },
    async goContract() {
      // 已签约 去查看合同
      if (this.data.signed === 2) {
        try {
          this.$loading('加载合同...');
          const res = await api.get('/api/vpai/vleader/contract/view');
          this.$loadingClose();
          if (res && res.data) {
            console.log('合同链接:', res.data);
            // 小程序环境：跳转到小程序 preview 页面打开 PDF
            if (this.isMiniProgram && window.wx && window.wx.miniProgram) {
              const contractUrl = encodeURIComponent(res.data);
              window.wx.miniProgram.navigateTo({
                url: `/pages/preview/index?url=${contractUrl}&fileType=pdf`
              });
            } else {
              window.location.href = res.data;
            }
          } else {
            this.$toast(res.message || '未获取到合同链接');
          }
        } catch (e) {
          this.$loadingClose();
          this.$toast(e.message || '获取合同失败');
        }
      } else if (this.data.signed === 1) { //未签约
        //先检查认证状态
        if (this.data.verified) {//已实名
          this.$dialog.confirm({
            title: '提示',
            message: '确定去签约吗?',
            confirmButtonText: '去签约'
          }).then(() => {
            this.goSign();
          });
        } else { //未实名
          this.$dialog.confirm({
            title: '提示',
            message: '为了更快捷为您结算收入，请实名认证及签约',
            confirmButtonText: '去认证'
          }).then(() => {
            this.go('auth-info');
          });
        }
      }
      // try {
      //   if (this.leader.ActiveStatus === 0) {
      //     this.$toast('请等待工作人员为您培训指导后进行操作');
      //     return;
      //   } else if (this.leader.ActiveStatus === 11) {
      //     this.$toast('您未通过考核，期待未来能与您合作');
      //     return;
      //   }
      //   if (this.authen !== 10) {
      //     this.$dialog.confirm({
      //       title: '提示',
      //       message: '为了更快捷为您结算收入，请实名认证及签约',
      //       confirmButtonText: '去认证'
      //     }).then(() => {
      //       this.go('auth-info');
      //     });
      //     return;
      //   }
      //   this.$loading();
      //   if (this.hasContracts.length) {
      //     let res = await this.$store.dispatch('postData', {
      //       url: '/recruit/GetCertificateViewUrl',
      //       data: {
      //         Extra: {
      //           PersonSysNo: this.$store.state.person.PersonSysNo,
      //           ThreePartyContractId: this.hasContracts[0].ThreePartyContractId
      //         }
      //       }
      //     });
      //     location.href = res.url + '&opentype=inwk';
      //   } else {
      //     if (!this.contracts.length) {
      //       this.$toast(`协议未生成，请稍后再试`);
      //       return;
      //     }
      //     let res = await this.$store.dispatch('postData', {
      //       url: '/recruit/SendContractStart',
      //       data: {
      //         Body: {
      //           PersonSysNo: this.$store.state.person.PersonSysNo,
      //           ContractSysNo: this.contracts[0].ContractSysNo,
      //           returnUrl: `https://signfinish.dasheng78.cn/ssq?cCode=${this.contracts[0].ContractSysNo}`
      //         }
      //       }
      //     });
      //     location.href = res.longUrl + '&opentype=inwk';
      //   }
      //   this.$loadingClose();
      // } catch (e) {
      //   this.$error(e.message);
      // }
    },

    async goSign() {
      try {
        const env = getEnv();
        // 只传路径，后端根据 sourceType 自己拼接完整的 redirectUrl
        const redirectPath = '/my-center';
        // 根据环境确定来源标识
        let sourceType = 'H5';
        if (env.envType === 'app') {
          sourceType = 'JybApp';
        } else if (env.envType === 'miniprogram') {
          sourceType = 'WxMini';
        }

        console.log('签约环境:', env.envType, '回调路径:', redirectPath, 'sourceType:', sourceType);

        const result = await api.get('/api/vpai/vleader/sign_contract', {
          params: {
            redirectUrl: redirectPath,
            sourceType: sourceType
          }
        });

        // 先判断 code 是否为 10000
        console.log('签约接口返回:', result);
        if (result.code !== 10000) {
          this.$error(result.message || '获取签约链接失败');
          setTimeout(() => {
            this.goBack();
          }, 1000);
          return;
        }

        // code 为 10000，检查是否有签约链接
        if (result.data && result.data.signUrl) {
          const signUrl = result.data.signUrl;

          // 小程序环境：使用 navigateTo 打开新页面
          if (env.envType === 'miniprogram' && window.wx && window.wx.miniProgram) {
            console.log('>>> 进入小程序分支，调用 navigateTo');
            const targetUrl = '/pages/esign/index?url=' + encodeURIComponent(signUrl);
            window.wx.miniProgram.navigateTo({
              url: targetUrl,
              success: function () {
                console.log('navigateTo 调用成功');
              },
              fail: function (err) {
                console.error('navigateTo 调用失败:', err);
                location.href = signUrl;
              }
            });
          } else {
            // 其他环境：直接跳转
            location.href = signUrl;
          }
        } else {
          this.$error('获取签约链接失败');
          setTimeout(() => {
            this.goBack();
          }, 1000);
        }
      } catch (e) {
        this.$error(e.message || '获取签约链接失败');
        setTimeout(() => {
          this.goBack();
        }, 1000);
      }
    },
    logout() {
      this.$dialog.confirm({
        title: '提示',
        message: '确定退出登录？'
      }).then(async () => {
        try {
          await this.$store.dispatch('postData', {
            url: '/api/vpai/vleader/login_out',
            data: {}
          });
        } catch (e) {
          console.log('退出登录接口调用失败，继续清理本地数据', e);
        }
        // 清理本地数据
        localStorage.removeItem('token');
        this.$store.commit('updatePerson', {});
        this.$store.commit('updateToHome', false);
        this.$store.commit('updateKeepAliveInclude', []);
        // 使用 replace 跳转，防止回退
        this.$router.replace('/login');
      }).catch(() => {
      });
    },
    async goAuthen() {
      if (this.leader.ActiveStatus === 0) {
        this.$toast('请等待工作人员为您培训指导后进行操作');
      } else if (this.leader.ActiveStatus === 11) {
        this.$toast('您未通过考核，期待未来能与您合作');
      } else {
        // 已实名状态，获取实名信息回填
        if (this.data.verified) {
          try {
            this.$loading('加载中...');
            const res = await api.get('/api/vpai/vleader/myVerified');
            this.$loadingClose();
            if (res && res.code === 10000 && res.data) {
              // 将实名信息存储到 sessionStorage，供目标页面读取
              sessionStorage.setItem('verifiedInfo', JSON.stringify(res.data));
              this.go('my-verify');
            } else {
              this.$toast(res.message || '获取实名信息失败');
            }
          } catch (e) {
            this.$loadingClose();
            this.$toast(e.message || '获取实名信息失败');
          }
        } else {
          // 未实名，跳转到认证页面
          this.go('auth-info');
        }
      }
    }
  }
};
</script>

<style lang="less">
@import '../../assets/css/theme.less';

.c-yellow {
  color: #FFEF00;
}

.ds-my-top {
  color: @white;
  padding: 24px 15px 24px;
  background: url('../../assets/images/my/banner-bg.png') no-repeat;
  background-size: cover;
}

.ds-my-top .copy {
  padding: 2px 7px;
  border-radius: 10px;
}

.ds-my-top .ds-avatar {
  width: 80px;
  height: 80px;
}

.ds-opcity-60 {
  opacity: .6;
}

.set-cell-height .van-cell {
  padding: 0 15px;
  height: 45px;
  line-height: 45px;
}

.set-cell-height .van-cell__left-icon,
.set-cell-height .van-cell__right-icon {
  line-height: 45px;
}
</style>
